<script>
	import Logo from './logo.svelte';
	let menuOpen = false;
	const links = [
		{ text: 'Rólunk', href: '/x/rolunk/' },
		{ text: 'Cikk beküldése', href: 'https://alap.toldygimnazium.hu/cikk-bekuldese/' },
		{ text: 'Belépés', href: 'https://alap.toldygimnazium.hu/log-in/' },
		{ text: 'Regisztráció', href: 'https://alap.toldygimnazium.hu/register/' }
	];
</script>

<header>
	<a href="/" data-sveltekit-preload-data>
		<h1>
			<Logo size={1} />
		</h1>
	</a>
	<a href="/search" title="Keresés">
		<img src="https://api.iconify.design/ph:magnifying-glass.svg" alt="" />
	</a>
</header>

<style lang="postcss">
	header {
		position: sticky;
		top: 0;

		-webkit-backdrop-filter: saturate(180%) blur(8px);
		backdrop-filter: saturate(180%) blur(8px);
		&:before {
			content: '';
			position: absolute;
			inset: 0;
			opacity: 0.6;
			z-index: -1;
			background-color: var(--surface-1);
		}

		z-index: 999;
		box-shadow: var(--shadow-1);

		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 1.5rem;

		padding-inline: 1em;

		height: 70px;

		overflow: hidden;
		white-space: nowrap;
		margin-bottom: 0.2em;

		--link: var(--text-1);
		--link-visited: var(--text-1);

		& a:hover {
			text-decoration: none;
		}
	}

	a {
		display: block;
		& img {
			width: 1.75em;
			height: 1.75em;
			transition: all 0.1s var(--ease-elastic-2);
			@media (prefers-color-scheme: dark) {
				filter: invert(1);
			}
		}
	}

	h1 {
		line-height: 1.2;
	}

	header a:last-of-type {
		& :hover {
			scale: 1.2;
		}
		& :focus-within {
			scale: 1;
		}
	}

	@supports ((-webkit-backdrop-filter: blur(2em)) or (backdrop-filter: blur(2em))) {
		nav,
		header {
			background: rgba(var(--surface-2), 0.9);
		}
	}
</style>
